// Chakra Icons
import { BellIcon, SearchIcon } from "@chakra-ui/icons";
// Chakra Imports
import {
  Button,
  Flex,
  Icon,
  IconButton,
  Input,
  InputGroup,
  InputLeftElement,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Text,
} from "@chakra-ui/react";
import ordericon from "assets/img/token--orderly.png";
import campaignicon from "assets/img/campaugn.png";
// Assets
import avatar1 from "assets/img/avatars/avatar1.png";
import avatar2 from "assets/img/avatars/avatar2.png";
import avatar3 from "assets/img/avatars/avatar3.png";
// Custom Icons
import { ProfileIcon, SettingsIcon } from "components/Icons/Icons";
// Custom Components
import { ItemContent } from "components/Menu/ItemContent";
import { SidebarResponsive } from "components/Sidebar/Sidebar";
import PropTypes from "prop-types";
import React, { useEffect } from "react";
import { NavLink } from "react-router-dom";
import myroute from "routes.js" ;
const routes = myroute.dashRoutes;
import { useHistory } from 'react-router-dom/cjs/react-router-dom';
import { RiLogoutCircleRLine } from 'react-icons/ri';
import useApiReq from 'variables/apireq';

export default function HeaderLinks(props) {
  const { variant, children, fixed, secondary, onOpen, ...rest } = props;
  const history = useHistory();

  useEffect(() => {
    if (!localStorage.getItem("token")) {
      history.push('/auth/login');
    }
  }, [])

  const logout = () => {
   
      localStorage.removeItem("token");
      localStorage.removeItem("group");
      
      history.push('/auth/login');
    

   
  }
  // Chakra Color Mode
  let inputBg = "#0F1535";
  let mainText = "gray.400";
  let navbarIcon = "white";
  let searchIcon = "white";

  if (secondary) {
    navbarIcon = "white";
    mainText = "white";
  }
        let userGroup = localStorage.getItem("group").toLowerCase();
          let publisherGroups = ["newsroom", "publisher", "editor", "marketing"];
    
          let targetGroup = publisherGroups.includes(userGroup)
            ? "publisher"
            : "advertiser";
  const settingsRef = React.useRef();
  return (
    <Flex
      pe={{ sm: "0px", md: "16px" }}
      w={{ sm: "100%", md: "auto" }}
      alignItems='center'
      flexDirection='row'
    >
      <NavLink to={`/${targetGroup}/profile`}>
        <Button
          ms='0px'
          px='0px'
          me={{ sm: "2px", md: "2px" }}
          color={navbarIcon}
          variant='transparent-with-icon'
          rightIcon={
            document.documentElement.dir ? (
              ""
            ) : (
              <ProfileIcon color={navbarIcon} w='22px' h='22px' me='0px' />
            )
          }
          leftIcon={
            document.documentElement.dir ? (
              <ProfileIcon color={navbarIcon} w='22px' h='22px' me='0px' />
            ) : (
              ""
            )
          }
        ></Button>
      </NavLink>
      <Button
        ms='0px'
        px='0px'
        me={{ sm: "2px", md: "16px" }}
        color={navbarIcon}
        variant='transparent-with-icon'
        onClick={logout}
      >
        <Icon as={RiLogoutCircleRLine} color={'white'} size={30}></Icon>
      </Button>
      <SidebarResponsive
        iconColor='gray.500'
        logoText={props.logoText}
        secondary={props.secondary}
        routes={routes}
        // logo={logo}
        {...rest}
      />
      {/* <SettingsIcon
        cursor="pointer"
        ms={{ base: "16px", xl: "0px" }}
        me="16px"
        ref={settingsRef}
        onClick={props.onOpen}
        color={navbarIcon}
        w="18px"
        h="18px"
      /> */}
      <Menu>
        <MenuButton align='center'>
          <BellIcon color={navbarIcon} mt='-4px' w='18px' h='18px' />
        </MenuButton>

        <MenuList
          border='transparent'
          backdropFilter='blur(63px)'
          bg='linear-gradient(127.09deg, rgba(6, 11, 40, 0.94) 19.41%, rgba(10, 14, 35, 0.69) 76.65%)'
          borderRadius='20px'
        >
          <Flex flexDirection='column'>
            <MenuItem
              borderRadius='8px'
              _hover={{
                bg: "transparent",
              }}
              _active={{
                bg: "transparent",
              }}
              _focus={{
                bg: "transparent",
              }}
              mb='10px'
            >
              <ItemContent
                time='13 minutes ago'
                info=''
                boldInfo='New Order#1'
                button='View'
                aSrc={ordericon}
              />
            </MenuItem>
            <MenuItem
              borderRadius='8px'
              _hover={{
                bg: "transparent",
              }}
              _active={{
                bg: "transparent",
              }}
              _focus={{
                bg: "transparent",
              }}
              mb='10px'
            >
              <ItemContent
                time='2 days ago'
                info=''
                boldInfo='New Order#2'
                button='View'
                aSrc={ordericon}
              />
            </MenuItem>
            <MenuItem
              borderRadius='8px'
              _hover={{
                bg: "transparent",
              }}
              _active={{
                bg: "transparent",
              }}
              _focus={{
                bg: "transparent",
              }}
            >
              <ItemContent
                time='3 days ago'
                info=''
                boldInfo='Campaign Started#21'
                button='View'
                aSrc={campaignicon}
              />
            </MenuItem>
          </Flex>
        </MenuList>
      </Menu>
    </Flex>
  );
}

HeaderLinks.propTypes = {
  variant: PropTypes.string,
  fixed: PropTypes.bool,
  secondary: PropTypes.bool,
  onOpen: PropTypes.func,
};
